module.exports = __webpack_public_path__ + "img/sentiment.348a3cb7.webp";